<template>
  <div class="ce-documentVersionHistoryEntry">
    <div class="ce-documentVersionHistoryEntry-version">
      {{ $t('documentVersionHistory.version') }} {{ item.version }}
    </div>

    <div class="ce-documentVersionHistoryEntry-filename">
      {{ item.filename }}
    </div>

    <div class="ce-documentVersionHistoryEntry-meta">
      <div>
        <fa-icon :icon="['far', 'clock']" />
        {{ niceCreatedDate }}
      </div>
      <div>
        <fa-icon :icon="['far', 'file']" />
        {{ niceFileSize }}
      </div>
    </div>

    <div v-if="item.changelog">
      {{ item.changelog }}
    </div>

    <div class="mt2">
      <a
        href=""
        class="ce-btn ce-btn--small ce-btn-light"
        @click.prevent="downloadAsset"
        target="_blank"
        :disabled="downloadRunning">
        <template v-if="!downloadRunning">
          {{ $t('documentVersionHistory.downloadCta') }} <fa-icon
            icon="download" />
        </template>
        <fa-icon
          v-else
          icon="spinner"
          spin />
      </a>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns';
import { axiosBlobClient } from 'utils/download';
import { formatByteSize } from 'utils';
import { saveAs } from 'file-saver';
import { mapState } from 'vuex';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      downloadRunning: false
    };
  },
  computed: {
    ...mapState('generic', ['services']),
    ...mapState('user', ['activeUser']),
    niceFileSize() {
      return formatByteSize(this.item.size, ' ');
    },
    niceCreatedDate() {
      return format(parseISO(this.item.createdDate), 'yyyy/MM/dd');
    }
  },
  methods: {
    async downloadAsset() {
      this.downloadRunning = true;

      let url = `${this.services.documentservice.url}/api/v2/document/download/${this.item.id}`;
      if (this.activeUser) url += `?jwt=${this.activeUser.token}`;

      try {
        const response = await axiosBlobClient.get(url);
        saveAs(new Blob([response.data]), this.item.filename);
        this.downloadRunning = false;
      } catch (e) {
        this.downloadRunning = false;
        this.$notification.error(e.response?.data?.message ?? e.message);
      }
    },
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-documentVersionHistoryEntry {
  &:not(:last-child) {
    margin-bottom: @space-3;
    padding-bottom: @space-3;
    border-bottom: 1px solid @color-mono-92;
  }

  .ce-documentVersionHistoryEntry-version {
    .ms(2);
    margin-bottom: @space-1;
  }

  .ce-documentVersionHistoryEntry-filename {
    .ms(-1);
  }

  .ce-documentVersionHistoryEntry-meta {
    .ms(-1);
    display: flex;
    .mxn2;

    > div {
      margin: @space-1 @space-2;
      display: flex;
      align-items: center;

      svg {
        margin-right: @space-2;
      }
    }
  }
}
</style>
